import React, { forwardRef } from "react";
import { Button, useTab, useMultiStyleConfig, Box, chakra, useTabsContext, } from "@chakra-ui/react";
import { motion, isValidMotionProp } from "framer-motion";
const ChakraBox = chakra(motion.div, {
    shouldForwardProp: isValidMotionProp,
});
const numberFormatter = new Intl.NumberFormat();
export const Tab = forwardRef(({ children, count }, ref) => {
    const tabProps = useTab({ ref });
    const styles = useMultiStyleConfig("Tabs", tabProps);
    const { id } = useTabsContext();
    const isSelected = Boolean(tabProps["aria-selected"]);
    return (React.createElement(Button, { __css: styles["tab"], className: "group", ...tabProps },
        children,
        typeof count === "number" && (React.createElement(Box, { as: "span", ml: 2, bg: "gray.200", textColor: "gray.700", borderRadius: "full", px: 2.5, py: 0.5, fontSize: "sm", _groupActive: {
                bg: "gray.300",
            } }, numberFormatter.format(count))),
        isSelected && (React.createElement(ChakraBox, { layoutId: id, position: "absolute", bottom: -0.5, left: 0, right: 0, h: 0.5, bg: "forest", zIndex: 2, 
            // @ts-expect-error Chakra UI has `transition` prop, which overrides Framer Motion's
            transition: {
                damping: 10,
                stiffness: 800,
            } }))));
});
